var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../../store';
import StartPlaybackModal from './start';
const externalMediaPlayerIsActiveSelector = createSelector(_react_refresh_temp_1 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.external_media_player_features;
}, (external_media_player_features) => external_media_player_features === null || external_media_player_features === void 0 ? void 0 : external_media_player_features.is_active);
$RefreshReg$(_react_refresh_temp_1, "externalMediaPlayerIsActiveSelector$createSelector");
const ExternalMediaPlayerModal = () => {
    _react_refresh_temp_3();
    const externalMediaPlayerIsActive = useAppSelector(externalMediaPlayerIsActiveSelector);
    return (_jsx(_Fragment, { children: !externalMediaPlayerIsActive ? (_jsx(StartPlaybackModal, { isActive: externalMediaPlayerIsActive !== null && externalMediaPlayerIsActive !== void 0 ? externalMediaPlayerIsActive : false })) : null }));
};
_react_refresh_temp_2 = ExternalMediaPlayerModal;
$RefreshReg$(_react_refresh_temp_2, "ExternalMediaPlayerModal");
_react_refresh_temp_3(ExternalMediaPlayerModal, "ExQtXBxrEwetRyTSjtRaepc7/kM=", false, () => [useAppSelector]);
export default ExternalMediaPlayerModal;
